<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="mb-5 w-100" v-show="!loading">
                    <button class="btn btn-primary float-right mr-2" @click="exportTransactionsAsCsv" id="btnCustomerTransactionsExportAsCsv">Export As CSV</button>
                </div>
                <div v-show="!loading">
                    <h6>Current Balance: {{currentBalance}}</h6>
                    <data-table :headings="customerTransactionHistoryHeadings" :data="customerTransactionHistory" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onTransactionActionClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Transaction Types</label>
                                        <bootstrap-select  :selectOptions="transactionTypes" :selectedOption="filter.selectedTransactionTypeId" :elementId="'transactionTypeFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onTransactionTypeFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="float-right pr-3">
                                            <from-date-to-date-pickers  :title="'Transaction Date'"
                                                                        :fromDate="filter.fromDateCreated"
                                                                        :toDate="filter.toDateCreated"
                                                                        :elementId="'transactionDateFilter'"
                                                                        :dateFormat="'dd/MM/yyyy'"
                                                                        @clearDatePicker="onDateFilterClearClick"
                                                                        @fromDateSelected="onFromDateCreatedSelect"
                                                                        @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    
    <modal-table
        :heading="productsModalTable.heading"
        :modalId="productsModalTable.modalId"
        :showModal="productsModalTable.showModal"
        :headings="productsModalTable.headings"
        :data="productsModalTable.products"
        :hasActions="false"
        :pagingDetails="productsModalTable.pagingDetails"
        @okClicked="onOkClicked"
        @pagingUpdated="onPagingUpdatedProducts"
        @filterSearchClicked="onFilterSearchClickedProductTable"></modal-table>
    
</div>
